import { useLocation, Link } from "react-router-dom";
import axios from "../axios";
import { useRef, useState, useEffect } from "react";

const ResetPassword = () => {
    const passRef = useRef();
    const errRef = useRef();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const email = searchParams.get("email");
    const token = searchParams.get("token");
    const [password, setPassword] = useState("");
    const [errMsg, setErrMsg] = useState("");

    useEffect(() => {
        passRef.current.focus();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.put(
                "/reset-password",
                {email, token, password},
                {headers: {"Content-Type": "application/json"}}
            );
            setPassword("");
            setErrMsg("Your password has been updated.");
        } catch (err) {
            console.log(err);
            if (!err?.response) {
                setErrMsg("No Server Response");
            } else if (err.response?.status === 400) {
                setErrMsg("Missing Username or Password");
            } else if (err.response?.status === 401) {
                setErrMsg("Unauthorized");
            } else {
                setErrMsg("Request Failed");
            }
            errRef.current.focus();
        }
    }

    return (
        <div style={{paddingTop:'10rem'}}>
            <form className="max-w-sm mx-auto" onSubmit={handleSubmit}>
                <p style={errMsg ? {padding:"0.75rem", marginBottom:'1rem', background:'#F8B4B4', fontSize:'14px', borderRadius:'7px', color:'#808080'} : null} ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">
                    {errMsg}
                </p>
                <div className="mb-5">
                    <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password</label>
                    <input 
                        type="password"
                        id="password"
                        ref={passRef}
                        autoComplete="current-password"
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                        placeholder="password"
                        required
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  
                    />
                </div>
                <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>
                <div className="flex items-start mb-5">
                <label htmlFor="remember" className="text-sm font-medium text-gray-900 dark:text-gray-300 pt-3">            
                    <Link to="/login">Login</Link>
                </label>
                </div>
            </form>
        </div>
    )
}

export default ResetPassword